/** Business names and units for the pricing parameters the backend defines. */

const PARAMETERS: Record<string, { label: string; unit: string; help: string }> = {
  FxBufferPct: {
    label: 'FX buffer',
    unit: '%',
    help: 'Added to the exchange rate to absorb movement.',
  },
  TargetMarginPct: { label: 'Target margin', unit: '%', help: 'Margin aimed for above cost.' },
  FloorPct: { label: 'Price floor', unit: '%', help: 'Lowest allowed margin over cost.' },
  CeilingPct: { label: 'Price ceiling', unit: '%', help: 'Highest allowed margin over cost.' },
  RoundingIncrement: { label: 'Rounding step', unit: '', help: 'Prices round to this step.' },
  MaximumFxAge: { label: 'Maximum FX age', unit: 'h', help: 'Older rates block pricing.' },
  MgmtFeePct: { label: 'Management fee', unit: '%', help: 'Platform fee on each sale.' },
  PartnerSharePct: { label: 'Partner share', unit: '%', help: 'Share passed to the partner.' },
};

export function parameterLabel(parameter: string): string {
  return PARAMETERS[parameter]?.label ?? parameter;
}

export function parameterUnit(parameter: string): string {
  return PARAMETERS[parameter]?.unit ?? '';
}

export function parameterHelp(parameter: string): string {
  return PARAMETERS[parameter]?.help ?? '';
}

export function formatParameter(parameter: string, value: number | null | undefined): string {
  if (value === null || value === undefined) return '—';
  const unit = parameterUnit(parameter);
  return unit === '%' ? `${value}%` : unit === 'h' ? `${value} h` : String(value);
}
